/**
 * Parse a money string (string with currency + value) into a number.
 * @param value - The string to parse.
 * @returns The parsed number.
 */
export const parseMoneyString = (value: string): number => {
    let cleaned = (value || '').replace(/[^0-9.,-]/g, '').replace(/,/g, '');

    // Currency symbols like "Fr." leave a stray leading period. When multiple
    // periods are present, only the last one is the decimal separator.
    const parts = cleaned.split('.');
    if (parts.length > 2) {
        cleaned = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1];
    }

    const num = parseFloat(cleaned);

    return isNaN(num) ? 0 : num;
};

/**
 * Format a number with a symbol.
 * @param amount - The number to format.
 * @param symbol - The symbol to prefix the number with.
 * @returns The formatted string.
 */
export const formatWithSymbol = (amount: number, symbol: string): string => {
    return `${symbol} ${amount.toFixed(2)}`;
};
